// Blocks submission of any form containing a filled [data-honeypot] field.
// Bots that auto-fill every input trip this; real visitors never see the field.
document.addEventListener('submit', function (event) {
  var form = event.target;
  if (!(form instanceof HTMLFormElement)) return;

  var honeypot = form.querySelector('[data-honeypot]');
  if (honeypot && honeypot.value !== '') {
    event.preventDefault();
  }
}, true);
